import { Box, IconButton, styled } from "@mui/material";
import axios from "axios";
import Button from "components/ui/Button";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { useGlobalContext } from "context/GlobalContext";
import { useEditCatalog } from "features/catalogue/hooks/useEditCatalog";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast as myToast } from "react-toastify";

import { isChanges } from "utils/checkExitCatalogUpdate";
import { RemoveCatalogDesigns, updateCatalogData } from "utils/updateCatalogData";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import SortContext from "context/SortContext";
import { useCatalogArchiveToUnarchive } from "features/Setting/archive/hook/useCatalogArchiveToUnarchive";

const StyledButton = styled(Button)(({ theme, bgcolor }) => ({
  width: "100%",
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: bgcolor,
  border: `1px solid ${bgcolor} `,
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: bgcolor,
    color: "black",
  },
  "&.Mui-disabled": {
    backgroundColor: "transparent",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

function CatalogueEditHeader({ Search, StyledInputBase, catalogueName = "" }) {
  const [open, setOpen] = useState(false);
  const [newName, setNewName] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [heading, setHeading] = useState("");
  const [modalType, setModalType] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const { mutate } = useCatalogArchiveToUnarchive();

  const isArchiveCatalog = location?.state && location?.state?.archiveCatalog ? location?.state?.archiveCatalog : false;

  const { isArchive, setIsArchive, checkCatalogBeforeNavigate, setCheckCatalogBeforeNavigate, newNameCatalog, setNewNameCatalog, setUpdateCatalogProductsData, searchPlaceHolder } = useGlobalContext();
  const { setSearch, search } = useContext(SortContext);

  const { archiveCatalog, setArchiveCatalog, removeIcon, checkedItems, setCheckedItems } = useGlobalContext();

  const activateCatalogArchive = useMemo(() => archiveCatalog?.length > 0 && isArchiveCatalog, [archiveCatalog, isArchiveCatalog])

  const handleDiscardChanges = useCallback(() => {
    let state = {
      name: location?.state?.name,
      view: false,
    }
    setNewName(catalogueName || "");
    setOpen(false);
    setIsArchive(false);
    setCheckCatalogBeforeNavigate(false);
    sessionStorage?.removeItem("checkedItems");
    setCheckedItems([]);
    navigate(`/Catalog/${params?.id}${location?.search}`, { state });
  }, [catalogueName]);

  const handleDiscardArchiveChanges = useCallback(() => {
    let state = {
      catalogSearch: "",
      edit: false,
      isActivity: false,
      name: ['Catalog'],
      subName: "",
      view: false,
    }
    navigate(`/Catalog`, { state });
    setArchiveCatalog([])
    sessionStorage.removeItem("catalogArchive")
  }, []);

  const handleArchiveCatalogs = () => {
    let state = {
      catalogSearch: "",
      edit: false,
      isActivity: false,
      name: ['Catalog'],
      subName: "",
      view: false,
    }
    mutate({ catalogIds: archiveCatalog, isArchive: true })
    navigate(`/Catalog`, { state });
    setArchiveCatalog([])
    sessionStorage.removeItem("catalogArchive")
  }

  const modalBtnInfo = useMemo(
    () => [
      {
        btnName: "Discard",
        bgColor: "#E77B7B",
        click: () => isArchiveCatalog ? handleDiscardArchiveChanges() : handleDiscardChanges(),
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setOpen(false),
      },
    ],
    [handleDiscardChanges]
  );

  const { mutate: updateCatalog } = useEditCatalog();

  const handleEditCatalogModalOpen = () => {
    setOpen(true);
    setModalType("remove");
    setHeading(`Remove ${checkedItems?.length} selected designs from catalog?`);
  };

  const handleEditCatalog = useCallback(() => {
    const data = RemoveCatalogDesigns();
    updateCatalog({ ...data, catalogName: newName, isArchive: isArchive, catalogId: params?.id, state: location?.state });
  }, [newName, isArchive, params?.id, location]);

  const handleCancelChanges = () => {
    setOpen(true)
    setModalType("discard");
    setHeading(removeIcon ? "Do you want to Discard the Catalog ?" : "Do you want to cancel the changes?")
  }

  const btnInfo = useMemo(
    () => [
      {
        btnName: "Save Changes",
        bgColor: "#50C878",
        click: () => isArchiveCatalog ? handleArchiveCatalogs() : checkedItems?.length > 0 ? handleEditCatalogModalOpen() : handleEditCatalog(),
      },
      {
        btnName: "Cancel",
        bgColor: "#E77B7B",
        click: () => {
          if (isArchiveCatalog) {
            archiveCatalog?.length > 0 ? handleCancelChanges() : handleDiscardArchiveChanges();
          } else {
            !removeIcon || !isChanges(catalogueName, newName, isArchive) ? handleDiscardChanges() : handleCancelChanges();
          }
        },
      },
    ],
    [handleEditCatalogModalOpen]
  );

  const removeCatalogUpdatInfo = useMemo(
    () => [
      {
        btnName: "Yes, Remove",
        bgColor: "#E77B7B",
        click: () => handleEditCatalog(),
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => {
          setOpen(false)
        }
      },
    ],
    [handleEditCatalog]
  );

  const checkCatalogUpdatInfo = useMemo(
    () => [
      {
        btnName: "Don’t Save",
        bgColor: "#E77B7B",
        click: handleDiscardChanges,
      },
      {
        btnName: "Save",
        bgColor: "#50C878",
        click: handleEditCatalog,
      },
    ],
    [handleEditCatalog]
  );

  const handleInputChange = useCallback((e) => {
    const newValue = e.target.value;
    setNewName(newValue);
    setNewNameCatalog(newValue);
  }, []);

  useEffect(() => {
    setNewName(catalogueName);
    setNewNameCatalog(catalogueName);
  }, [catalogueName]);

  useEffect(() => {
    return (() => {
      sessionStorage?.removeItem("checkedItems");
      setCheckedItems([]);
    })
  }, [location]);

  const handleSearch = () => {
    setSearch(tempSearch);
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
        {isArchiveCatalog ?
          <Search
            sx={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "10px",
              paddingRight: "4px",
            }}
          >
            {/* Search Icon inside Input */}
            <SearchIconPlaceHolder sx={{ color: "gray", marginRight: "8px" }} />

            <StyledInputBase
              placeholder={searchPlaceHolder}
              onChange={(e) => setTempSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              value={tempSearch}
              inputProps={{ "aria-label": "search" }}
              sx={{ height: "40px", borderRadius: "5px" }}
            />

            <IconButton
              disableRipple
              disableFocusRipple
              sx={{
                color: "black",
                height: "34px",
                width: "69px",
                borderRadius: "5px",
                padding: "10px",
                background: "#000",
                fontFamily: "poppins",
                color: "#fff",
                fontWeight: "500",
                fontSize: "12px",
              }}
              onClick={search === "" ? handleSearch : () => setSearch("")}
            >
              {search === "" ? "Search" : "Clear"}
            </IconButton>
          </Search>
          : <Search>
            <StyledInputBase onChange={handleInputChange} value={newName} inputProps={{ "aria-label": "search" }} />
          </Search>}
        {btnInfo &&
          btnInfo.map((btn) => (
            <Box key={btn.btnName}>
              <StyledButton bgcolor={btn.bgColor} onClick={btn.click} disabled={
                btn.btnName === "Save Changes" ? isArchiveCatalog ? !activateCatalogArchive : checkedItems?.length > 0 || isChanges(catalogueName, newName, isArchive) ? false : true : false
              }>
                {btn.btnName}
              </StyledButton>
            </Box>
          ))}
        {/* <MyToastContainer /> */}
      </Box>
      <RemoveModal open={open} setOpen={setOpen} btnInfo={modalType === "remove" ? removeCatalogUpdatInfo : modalBtnInfo} heading={heading} />
      <RemoveModal open={checkCatalogBeforeNavigate} setOpen={setCheckCatalogBeforeNavigate} btnInfo={checkCatalogUpdatInfo} heading="Do you want to Save the Changes?" />
    </>
  );
}

export default CatalogueEditHeader;
